/**
 * Get size of Bytes6 (always 6)
 *
 * @param {import('./Bytes6Type.js').Bytes6Type} _bytes - Bytes6
 * @returns {6} Size (always 6)
 *
 * @example
 * ```typescript
 * const size = Bytes6.size(bytes); // 6
 * ```
 */
export function size(_bytes) {
	return 6;
}
